import styled from "styled-components";
import Row from "../Row";
import Col from "../Col";
import { theme } from "../../../Methods/theme";
import { DarkColorConstruction } from "../../../Methods/HexToRgba";

const color = (type) => {
    switch (type) {
        case "success":
            return `${theme.true}`;
        case "error":
            return `${theme.danger}`;
        case "warning":
            return `${theme.warning}`;
        case "info":
            return `${theme.info}`;
        default:
            break;
    }
};

export const ToastWrapper = styled(Col)`
    position: fixed;
    width: auto;
    height: auto;
    top: 20px;
    right: 0;
    align-items: flex-start;
    justify-content: flex-start;
    z-index: 100;
`
export const Notification = styled(Row)`
    width: 300px;
    height: ${(props) => props.height};
    @keyframes show-toast {
        0% {
            transform: translateX(305px);
        }
        100% {
            transform: translateX(0);
        }
    }
    @keyframes hide-toast {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(305px);
        }
    }
    @keyframes toast-progress {
        0% {
            width: 0;
        }
        100% {
            width: 100%;
        }
    }
    animation: ${(props) => props.animation} ${(props) => props.animationDuration + "ms"} ease both;
    .progress {
        animation: toast-progress ${(props) => props.animationDuration + 2000 + "ms"} ease both;
        animation-delay: 800ms;
        height: 4px;
        background-color: ${(props) => DarkColorConstruction(color(props.type), 30)};
        margin-bottom: -2px;
        z-index: 2;
    }
    .background {
        width: 100%;
        height: auto;
        min-height: 80px;
        background-color: ${(props) => color(props.type)};
        border-radius: 3px 0 0 3px;
        padding: 15px;
        margin-bottom: 20px;
        align-items: flex-start;
    }
`
export const IconContainer = styled(Col)`
    width: 50px;
    > div {
        width: 32px;
        height: 32px;
        margin-left: auto;
        margin-top: 3px;
    }
    &.success,
    &.info {
        > div {
            background-color: ${theme.whiteIndex};
            border-radius: 50%;
            svg {
                fill: ${(props) => color(props.type)};
                width: 16px;
                height: 16px;
            }
        }
    }
    &.error > div  {
        background-color: ${theme.whiteIndex};
        border-radius: 50%;
        svg {
            fill: ${(props) => color(props.type)};
            width: 21px;
            height: 21px;
        }
    }
    &.warning > div  {
        svg {
            fill: ${theme.whiteIndex};
            width: 29px;
            height: 29px;
        }
    }
`;
export const ContentContainer = styled(Col)` //متن خطا
    width: calc(100% - 60px);
    height: auto;
    text-align: justify;
    color: #fff;
    .notification-title {
        font-size: 13.5px;
    }
    .notification-message {
        font-size: 13px;
        padding: 0 7px 0 10px;
        margin-bottom: 5px;
        margin-top: ${(props) => props.type === "info" ? "9px" : "5px"};
    }
`;
export const CloseIconContainer = styled(Col)`
    width: auto;
    height: auto;
    margin-bottom: auto;
    cursor: pointer;
    svg {
        width: 10px;
        height: 10px;
        fill: ${theme.whiteIndex};
    }
`;